function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
import { request as baseRequest } from "@xo-union/fetch-request-builder";
import configure from "../configure/index.js";
var _request = /*#__PURE__*/new _WeakMap();
var ConversationsClient = /*#__PURE__*/function () {
  function ConversationsClient() {
    _classCallCheck(this, ConversationsClient);
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classPrivateFieldInitSpec(this, _request, {
      writable: true,
      value: void 0
    });
    var _configure = configure(config),
      host = _configure.host;
    var _config$request = config.request,
      request = _config$request === void 0 ? baseRequest : _config$request;
    _classPrivateFieldSet(this, _request, request.host(host).path('/local-partners/api/conversation-theknot/conversations'));
  }
  _createClass(ConversationsClient, [{
    key: "getInboxUnreadMessagesCount",
    value: function getInboxUnreadMessagesCount(_ref) {
      var memberId = _ref.memberId;
      return _classPrivateFieldGet(this, _request).get("/count/".concat(memberId)).query({
        filter: 'inbox',
        status: 'unread'
      }).readJsonBody();
    }
  }]);
  return ConversationsClient;
}();
export { ConversationsClient as default };